import React from 'react'
import { ArrayInput, SimpleFormIterator, TextInput } from 'react-admin'
import { PricingRuleSet } from 'services/api/entities/catalog/types'
import KAccordion from 'ui-shared/accordions/KAccordion'
import Kdivider from 'ui-shared/LayoutComponents/Kdivider'
import TimePicker from 'ui-shared/WrappedInputs/TimePicker'
import PricingByRulesInput from './PricingByRulesInput'
import PricingRulePriceInputGroup from './PricingRulePriceInputGroup'

const defaultRuleSetValue: Partial<PricingRuleSet>[] = [
  {
    periodFrom: '--01-01',
    periodTo: '--12-31',
    dayFrom: 'monday',
    dayTo: 'sunday',
  },
]

const ProfessionalByRulePricingInput: React.FC<{ source?: string }> = ({
  source,
}) => (
  <KAccordion accordionTitle="Cost & Prices">
    <PricingByRulesInput defaultValue={defaultRuleSetValue}>
      <h2>Base Price</h2>
      <PricingRulePriceInputGroup />
      <Kdivider />
      <h2>Shifts</h2>
      <ArrayInput source="shiftPricingRules" label="">
        <SimpleFormIterator>
          <TextInput source="name" label="form.fields.name" />
          <TimePicker source="hoursFrom" label="From" />
          <TimePicker source="hoursTo" label="To" />
          <PricingRulePriceInputGroup />
        </SimpleFormIterator>
      </ArrayInput>
    </PricingByRulesInput>
  </KAccordion>
)

export default ProfessionalByRulePricingInput
